// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@supports (-webkit-appearance:-apple-pay-button){.apple-pay-button[data-v-c6156496]{display:block;-webkit-appearance:-apple-pay-button;height:48px;cursor:pointer;width:100%;max-width:100px;border-radius:12px}.apple-pay-button-black[data-v-c6156496]{-apple-pay-button-style:#000}}@supports not (-webkit-appearance:-apple-pay-button){.apple-pay-button[data-v-c6156496]{display:none!important}}", ""]);
// Exports
module.exports = exports;
